
import React, { Suspense } from 'react';
import ModernTemplate from './modern/ModernTemplate';
import { BookingPageSkeleton } from '../shared/LoadingStates';

// Export types for external usage - simplified to only Modern
export type TemplateType = 'modern';

export const isValidTemplate = (template: string): template is TemplateType => {
  return template === 'modern';
};

interface TemplateRendererProps {
  meetingLink: any;
  troubleshootMode?: boolean;
  isDebugMeeting?: boolean;
  forceMobileLayout?: boolean;
}

export const TemplateRenderer: React.FC<TemplateRendererProps> = ({
  meetingLink,
  troubleshootMode = false,
  isDebugMeeting = false,
  forceMobileLayout = false
}) => {
  // Always use Modern template
  const businessSlug = meetingLink?.profiles?.business_slug || 'default';

  return (
    <Suspense fallback={<div className="min-h-screen bg-white" />}>
      <ModernTemplate 
        meetingLink={meetingLink}
        businessSlug={businessSlug}
        troubleshootMode={troubleshootMode}
        isDebugMeeting={isDebugMeeting}
        forceMobileLayout={forceMobileLayout}
      />
    </Suspense>
  );
};

// Template loader component for external use
interface TemplateLoaderProps {
  template: TemplateType;
  meetingLink: any;
  businessSlug: string;
  isDebugMeeting?: boolean;
  urlParams?: Record<string, any>;
  troubleshootMode?: boolean;
  forceMobileLayout?: boolean;
}

export const TemplateLoader: React.FC<TemplateLoaderProps> = (props) => {
  // Always use Modern template regardless of template prop
  return <TemplateRenderer {...props} />;
};
